<template>
  <div
    class="download"
    @scroll.passive="scroll($event)"
  >
    <!-- <topMenu pageType="recommend" /> -->
    <van-nav-bar :title="'联吧/' + title" />
    <div class="input_box">
      <div
        class="search_box"
        @click="tosearch"
      >
        <input
          disabled
          class="search"
          type="text"
          placeholder="搜索视频 / 图文教程"
        />
        <div class="icon">
          <van-icon
            name="search"
            color="#919191"
            size="18"
          />
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="tips_box">{{title}}:</div>
      <div
        class="list_box"
        @scroll.passive="scroll($event)"
      >
        <template v-if="!show">
          <div
            class="box"
            @click="toLink(item)"
            v-for="(item,index) in list"
            :key="index"
          >
            <div class="title">{{item.cate_name}}</div>
            <van-icon
              name="arrow"
              color="#919191"
              size="20"
            />
          </div>
        </template>
        <div
          class="details"
          v-else
        >
          <div
            class="tItems"
            v-for="(item, index) in list1"
            :key="index"
            @click.stop="toDetail(item.h5_id,item.type)"
          >
            <img :src="item.page_img" />
            <a :id="'title'+ index" />
            <p>{{index + 1}}.{{item.title}}</p>
            <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
          </div>
        </div>
      </div>

    </div>

    <isWeixinMark
      :isWeixin="isWeixin"
      @onCancelMark="isWeixin = false"
    />
    <div
      class="downloadImage"
      @click="onDownload"
    >
      <img src="../assets/images/xiazai_duan.png" />
    </div>
  </div>
</template>

<script>
// import topMenu from '../components/topMenu'
import isWeixinMark from '../components/isWeixinMark'
import { getList, getFirmCateList, getWapFirmList } from '../api/wap'
export default {
  name: 'download',
  components: {
    // topMenu,
    isWeixinMark
  },
  data () {
    return {
      downloadLink: '',
      isWeixin: false,
      loading: false,
      finished: false,
      page: 1,
      page_total: 1,
      list: [],
      get_key: '',
      title: '',
      list1: [],
      show: false
    }
  },
  created () {
    if (this.$route.query.get_key) this.get_key = this.$route.query.get_key
    this.onLoadData()
    this.getlist()
  },
  methods: {
    onLoadData () {
      getList({ type: 1 }).then((res) => {
        this.downloadLink = res.result.download_url.android
      })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href =
          'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    },
    getlist () {
      getFirmCateList({
        page_now: this.page,
        get_key: this.get_key,
        cate_id: '',
        cate_level: 1
      }).then(res => {
        this.title = res.result.firm_name
        if (this.page === 1) {
          this.list = res.result.lists
          if (res.result.lists.length === 0) {
            this.show = true
            this.getAll()
          }
        } else {
          this.list.push(...res.result.lists)
        };
        this.page_total = res.result.page_total
      })
    },
    getAll () {
      getWapFirmList({
        page_now: this.page,
        get_key: this.get_key,
        cate_id: '',
        cate_level: 0
      }).then(res => {
        if (this.page === 1) {
          this.list1 = res.result.lists
        } else {
          this.list1.push(...res.result.lists)
        }
        // this.page_total = res.result.page_total
      })
    },
    toLink (item) {
      getFirmCateList({
        cate_id: item.cate_id,
        cate_level: item.cate_level + 1,
        // get_key: this.get_key,
        page_now: 1
      }).then(res => {
        localStorage.setItem('lower2', JSON.stringify(res.result.lists[0]))
        if (res.result.lists.length > 0) {
          this.$router.push({
            path: '/secondary',
            query: {
              id: item.cate_id,
              cate_level: item.cate_level,
              title: this.title,
              key: this.get_key
            }
          })
        } else {
          this.$router.push({
            path: '/fullyGood',
            query: {
              id: item.cate_id,
              cate_level: item.cate_level,
              title: this.title,
              key: this.get_key
            }
          })
        }
      })
    },
    tosearch () {
      // console.log(222);
      this.$router.push({
        path: '/search',
        query: {
          key: this.get_key
        }
      })
    },
    scroll (e) {
      if (this.show) return
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.getlist()
        }
      }
    },
    toDetail (id, type) {
      if (+type === 2) {
        this.$router.push({
          path: '/newDirectionsDetail',
          query: {
            id: id,
            key: this.get_key
          }
        })
      } else {
        this.$router.push({
          path: '/newVideoDetail',
          query: {
            id: id,
            key: this.get_key
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.downloadImage {
  /* margin-top: 1rem; */
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.2rem 0 0.2rem;
  background: #ffff;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download {
  height: 100%;
  /* background-color: #f3f3f3; */
  display: flex;
  flex-direction: column;
}
.search_box {
  width: 100%;
  background-color: #fff;
  padding: 0.2rem 0.2rem;
  position: relative;
  height: 1.1rem;
  display: flex;
}
.tips_box {
  margin-top: 0.24rem;
  font-size: 0.34rem;
  color: #121212;
  padding-left: 0.24rem;
}
.inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.list_box {
  padding: 0.28rem 0.48rem 0;
  flex: 1;
  overflow-y: auto;
}
.box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  box-shadow: 0px 0px 0.46rem 0px rgba(0, 0, 0, 0.13);
  margin-bottom: 0.26rem;
  min-height: 1.5rem;
  border-radius: 0.16rem;
}
.title {
  width: 5.45rem;
  font-size: 0.42rem;
  color: #121212;
  font-weight: 500;
  line-height: 0.5rem;
}
.search {
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 0.3rem;
  font-size: 15px;
  background: #e7e7e7;
  border-radius: 0.35rem;
  border: none !important;
  line-height: 0.3rem;
}
.icon {
  position: absolute;
  top: 50%;
  right: 0.4rem;
  transform: translateY(-50%);
  align-items: center;
  height: 0.7rem;
  display: flex;
}
.details {
  padding: 0 0.1rem 0;
  /* display: flex;
  flex-wrap: wrap; */
  /* background: #fff; */
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(calc(100% - 0.2rem) / 2));
  gap: 0.3rem 0.2rem;
}
.tItems {
  /* margin-bottom: 0.3rem;
  width: 3.45rem; */
  width: 100%;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  /* margin-left: 0.1rem;
  margin-right: 0.1rem; */
  padding-bottom: 0.2rem;
}
.tItems p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItems img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
/* .downloadImage {
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1.2rem 0;
  background: #f3f3f3;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download {
  height: 100vh;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
}
.van-hairline--bottom::after {
  border: none !important;
}
.input_box {
  padding: 0.2rem 0.4rem;
}
.search_box {
  width: 100%;
  position: relative;
  height: 0.9rem;
  display: flex;
  align-items: center;
}
.search_box .search {
  height: 100%;
  background: #fff;
  border-radius: 0.05rem;
  border: 1px solid rgba(216, 216, 216, 1);
  width: 100%;
  font-size: 0.28rem;
  padding: 0 0.2rem;
}
.search_box .icon {
  position: absolute;
  top: 50%;
  right: 0.2rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}
.inner >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.inner {
  padding-bottom: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tips_box {
  font-size: 0.28rem;
  line-height: 0.6rem;
  padding-left: 0.2rem;
  display: flex;
  align-items: center;
}
.list_box {
  flex: 1;
  overflow: auto;
} */
</style>
